import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import AuthContext from 'context/AuthContext'
// routes
import MainRoutes from './MainRoutes'
import AdminRoutes from './AdminRoutes'
import { listenEvent } from 'utils/initializeSocket'
import helpers from 'utils/helpers'
import apiPath from 'utils/apiPath'
import { apiGet } from 'utils/apiFetch'
import Zendesk, { ZendeskAPI } from 'utils/ZendexConfig'
import AnnouncementMarquee from 'components/reusable/AnnouncementMarque'

export default function CombineRoutes() {
  const { user, socketConnect, socket,globalSetting } = useContext(AuthContext)
  const { pathname: pathName } = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    if (user) {
      socketConnect()
    }


  }, [user])

  useEffect(() => {
    if (helpers.orOperator(!socket, !('Notification' in window))) return;

    const handleNotificationPermission = (data) => {
      if (Notification.permission === 'granted') {
        showNotification(data);
      } else {
        requestNotificationPermission(data);
      }
    };

    const requestNotificationPermission = (data) => {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          showNotification(data);
        } else {
          console.warn("Notification permission denied.");
        }
      });
    };

    const showNotification = (data) => {
      const notification = new Notification('Message :', {
        body: data?.message
      });

      notification.onclick = () => navigate('/notification-manager');
    };

    const handleNewNotification = (data) => {
      if (data?.newNotificationMessage) {
        handleNotificationPermission(data);
      }
    };

    listenEvent(socket, 'newNotificationMessage', handleNewNotification);

  }, [socket]);



  const hideZendeskIfReady = () => {
    if (typeof window !== 'undefined' && typeof window.zE === 'function') {
      ZendeskAPI("messenger", "logoutUser")
      ZendeskAPI("messenger", "hide")
      ZendeskAPI("messenger", "close")
      console.log('Zendesk is initialized and now hidden.');
    }
    else {
      setTimeout(hideZendeskIfReady, 100);
    }
  };
  const handleLoaded = async () => {
    try {
      if (pathName == '/help-and-support' && typeof window !== 'undefined' && typeof window.zE === 'function') {
        const resp = await apiGet(apiPath.getZendeskToken);
        if (resp?.data?.success) {
          const jwt = resp?.data?.results;
          ZendeskAPI('messenger', 'loginUser',
            function jwtCallback(callback) {
              callback(jwt);
            },
            function loginCallback(error) {
              if (error) {
                console.error('Zendesk login failed', error);
              } else {
                console.log('Zendesk login successful');
                ZendeskAPI("messenger", "show")
              }
            }
          );
        }
      } else {
        hideZendeskIfReady()
      }
    } catch (err) {
      console.error('Error loading Zendesk token', err);
    }
  };


  useEffect(() => {
    if (user) {
      if (pathName !== '/help-and-support') {

        hideZendeskIfReady()
      } else {
        handleLoaded()
      }
    }
  }, [pathName, user])


  const checkRoles = {
    admin: AdminRoutes,
    subAdmin: AdminRoutes
    // "company": CompanyRoutes
  }
  return (<>
    {helpers.andOperator(user&&globalSetting?.announcementData?.announcementStatus,<AnnouncementMarquee  announcementData={globalSetting?.announcementData}/>)}
    {useRoutes([helpers.ternaryCondition(user, checkRoles.admin, MainRoutes)], process.env.BASENAME)}
    {helpers.andOperator(user, <Zendesk defer zendeskKey={process.env.REACT_APP_ZENDESK_KEY} onLoaded={handleLoaded} />)}
  </>)
}
